import { motion } from 'framer-motion'
import SectionWrapper from '../layout/SectionWrapper'

const moments = [
  {
    title: 'Tu Entres dans Mon Monde',
    date: '23 mars 2025',
    description: 'Tu rencontres ma famille et mes amis. Tu deviens partie intégrante de ma vie.',
    emoji: '👨‍👩‍👧‍👦',
    icon: '🏠'
  },
  {
    title: 'Cabane à Sucre',
    date: 'Avril 2025',
    description: 'Nos valeurs partagées se révèlent. La foi, l\'amour, l\'égalité, l\'humour.',
    emoji: '🍁',
    icon: '🥞'
  }
]

const values = [
  { emoji: '🙏', label: 'Foi', color: 'from-primary-pink to-accent-pink' },
  { emoji: '❤️', label: 'Amour', color: 'from-accent-pink to-accent-coral' },
  { emoji: '⚖️', label: 'Égalité', color: 'from-accent-coral to-light-pink-300' },
  { emoji: '😂', label: 'Humour', color: 'from-light-pink-300 to-primary-pink' }
]

export default function IntegrationSection() {
  return (
    <SectionWrapper
      id="integration"
      gradient="from-dark-secondary via-dark-primary to-dark-secondary"
    >
      {/* Header */}
      <motion.div className="text-center mb-16">
        <motion.span
          className="tag-pill mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span>🌟</span>
          <span>L'Intégration</span>
        </motion.span>

        <motion.h2
          className="text-4xl md:text-6xl font-serif font-bold gradient-text mb-4"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Tu Entres dans Mon Monde
        </motion.h2>
      </motion.div>

      {/* Moments Grid */}
      <div className="grid md:grid-cols-2 gap-8 mb-16">
        {moments.map((moment, index) => (
          <motion.div
            key={moment.title}
            className="glass-card"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.2 }}
            whileHover={{ y: -5, boxShadow: '0 20px 40px rgba(232, 81, 178, 0.2)' }}
          >
            <div className="flex items-start gap-4">
              <span className="text-5xl">{moment.emoji}</span>
              <div>
                <span className="text-sm text-primary-pink">{moment.date}</span>
                <h3 className="text-2xl font-serif font-bold text-white mt-1 mb-3">
                  {moment.title}
                </h3>
                <p className="text-light-pink-100/70">
                  {moment.description}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Values */}
      <motion.div
        className="text-center"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        <h3 className="text-2xl font-serif font-bold text-white mb-8">
          Nos Valeurs Partagées
        </h3>

        <div className="flex flex-wrap justify-center gap-4">
          {values.map((value, index) => (
            <motion.div
              key={value.label}
              className={`flex items-center gap-3 px-6 py-4 rounded-2xl bg-gradient-to-r ${value.color} bg-opacity-20`}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <span className="text-3xl">{value.emoji}</span>
              <span className="text-lg font-semibold text-white">{value.label}</span>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* Quote */}
      <motion.blockquote
        className="text-center mt-16 max-w-2xl mx-auto"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <p className="text-xl md:text-2xl text-light-pink-100/80 italic font-serif leading-relaxed">
          "Tu n'étais plus une inconnue dans ma vie
          <br />
          Tu devenais celle pour qui mon coeur vit"
        </p>
        <footer className="mt-4 text-primary-pink text-sm">
          — Verse 2
        </footer>
      </motion.blockquote>
    </SectionWrapper>
  )
}
